import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { 
    FaShieldAlt, 
    FaUserSecret, 
    FaLock, 
    FaEye, 
    FaDatabase,
    FaCookieBite,
    FaEnvelope,
    FaPhone,
    FaGlobe
} from 'react-icons/fa';
import './About.css';
import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';

const Privacy = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="about-page">
            <BannerWithBreadcrumb
                title="Privacy Policy"
                breadcrumbItems={[
                    { label: 'Home', link: '/' },
                    { label: 'Privacy Policy' }
                ]}
            />
            {/* Privacy Content */}
            <section className="content-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                            >
                                <Card className="privacy-card">
                                    <Card.Body>
                                        <h2>1. Information We Collect</h2>
                                        <p>We collect information you provide directly to us, such as when you:</p>
                                        <ul>
                                            <li>Create an account or profile</li>
                                            <li>Add or edit business listings</li>
                                            <li>Contact us for support</li>
                                            <li>Subscribe to our newsletter</li>
                                            <li>Leave reviews or ratings</li>
                                        </ul>

                                        <h3>Personal Information</h3>
                                        <p>This may include:</p>
                                        <ul>
                                            <li>Name and contact information</li>
                                            <li>Business information and details</li>
                                            <li>Payment information (processed securely)</li>
                                            <li>Communication preferences</li>
                                        </ul>

                                        <h3>Automatically Collected Information</h3>
                                        <p>We automatically collect certain information when you use our services:</p>
                                        <ul>
                                            <li>Device information (IP address, browser type)</li>
                                            <li>Usage data (pages visited, time spent)</li>
                                            <li>Location information (with your consent)</li>
                                            <li>Cookies and similar technologies</li>
                                        </ul>

                                        <h2>2. How We Use Your Information</h2>
                                        <p>We use the information we collect to:</p>
                                        <ul>
                                            <li>Provide and improve our services</li>
                                            <li>Process business listings and updates</li>
                                            <li>Send you important updates and notifications</li>
                                            <li>Respond to your inquiries and support requests</li>
                                            <li>Analyze usage patterns to enhance user experience</li>
                                            <li>Prevent fraud and ensure security</li>
                                        </ul>

                                        <h2>3. Information Sharing</h2>
                                        <p>We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:</p>
                                        <ul>
                                            <li><strong>With your consent:</strong> When you explicitly agree to share information</li>
                                            <li><strong>Service providers:</strong> Trusted partners who help us operate our services</li>
                                            <li><strong>Legal requirements:</strong> When required by law or to protect our rights</li>
                                            <li><strong>Business transfers:</strong> In connection with a merger or acquisition</li>
                                        </ul>

                                        <h2>4. Data Security</h2>
                                        <p>We implement appropriate security measures to protect your information:</p>
                                        <ul>
                                            <li>Encryption of sensitive data in transit and at rest</li>
                                            <li>Regular security assessments and updates</li>
                                            <li>Access controls and authentication</li>
                                            <li>Secure data centers and infrastructure</li>
                                        </ul>

                                        <h2>5. Your Rights and Choices</h2>
                                        <p>You have the right to:</p>
                                        <ul>
                                            <li><strong>Access:</strong> Request a copy of your personal information</li>
                                            <li><strong>Update:</strong> Correct or update your information</li>
                                            <li><strong>Delete:</strong> Request deletion of your account and data</li>
                                            <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
                                            <li><strong>Portability:</strong> Request data in a portable format</li>
                                        </ul>

                                        <h2>6. Cookies and Tracking</h2>
                                        <p>We use cookies and similar technologies to:</p>
                                        <ul>
                                            <li>Remember your preferences and settings</li>
                                            <li>Analyze website traffic and usage</li>
                                            <li>Provide personalized content and ads</li>
                                            <li>Improve our services and user experience</li>
                                        </ul>
                                        <p>You can control cookie settings through your browser preferences.</p>

                                        <h2>7. Third-Party Services</h2>
                                        <p>Our services may contain links to third-party websites or integrate with third-party services. We are not responsible for the privacy practices of these third parties.</p>

                                        <h2>8. Children's Privacy</h2>
                                        <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>

                                        <h2>9. International Data Transfers</h2>
                                        <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.</p>

                                        <h2>10. Changes to This Policy</h2>
                                        <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by:</p>
                                        <ul>
                                            <li>Posting the updated policy on our website</li>
                                            <li>Sending you an email notification</li>
                                            <li>Displaying a notice on our services</li>
                                        </ul>

                                        <h2>11. Contact Us</h2>
                                        <p>If you have questions about this Privacy Policy or our privacy practices, please contact us:</p>
                                        <div className="contact-info">
                                            <div className="contact-item">
                                                <FaEnvelope className="contact-icon" />
                                                <div>
                                                    <h6>Email</h6>
                                                    <p>privacy@businessdirectory.com</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaPhone className="contact-icon" />
                                                <div>
                                                    <h6>Phone</h6>
                                                    <p>+1 (555) 123-4567</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaGlobe className="contact-icon" />
                                                <div>
                                                    <h6>Address</h6>
                                                    <p>123 Business Ave, Suite 100<br />City, State 12345</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Privacy; 